import * as ids from '@wix/app-definition-ids'

import type { Experiments } from '../../../../utils/experiments'

const FITNESS_SEGMENT_ID = 'fitness-services'
const FITNESS_PRICING_PLANS_SPEC = 'specs.funnel.SectorToAppFitnessPricingPlans'
const SECTOR_TO_APP_V2_SPEC = 'funnelSectorToAppV2'

const segmentToAppIds: Record<string, string[]> = {
  'beauty-wellness-services': [ids.WIX_BOOKINGS],
  'blog-content': [ids.WIX_BLOG, ids.INSTAGRAM_FEED_NEW],
  'business-professionals': [ids.WIX_BOOKINGS],
  'construction-production-services': [ids.WIX_BOOKINGS],
  'consumer-stores': [ids.WIX_NEW_STORES, ids.INSTAGRAM_FEED_NEW],
  'creative-services': [ids.WIX_BOOKINGS],
  education: [ids.WIX_BOOKINGS, ids.WIX_CHALLENGES],
  'field-services': [ids.WIX_BOOKINGS],
  'fitness-services': [ids.WIX_BOOKINGS, ids.INSTAGRAM_FEED_NEW],
  'health-services': [ids.WIX_BOOKINGS],
  hotels: [
    ids.WIX_RESTAURANTS_MENUS_NEW,
    ids.WIX_RESTAURANTS_ORDERS_NEW,
    ids.WIX_RESTAURANTS_TABLE_RESERVATIONS,
    ids.WIX_HOTELS_RUNNER,
  ],
  'non-profit-communities': [ids.WIX_EVENTS, ids.WIX_DONATIONS, ids.WIX_GROUPS],
  'other-services': [ids.WIX_BOOKINGS],
  photographers: [ids.WIX_PORTFOLIO],
  portfolio: [ids.WIX_PORTFOLIO],
  'private-events': [ids.WIX_EVENTS],
  'public-events': [ids.WIX_EVENTS],
  'real-estate': [ids.WIX_BOOKINGS],
  restaurants: [ids.WIX_RESTAURANTS_MENUS_NEW, ids.WIX_RESTAURANTS_ORDERS_NEW, ids.WIX_RESTAURANTS_TABLE_RESERVATIONS],
  'science-technology-services': [],
  'tours-activities-services': [ids.WIX_BOOKINGS, ids.INSTAGRAM_FEED_NEW],
  'wholesale-stores': [ids.WIX_NEW_STORES],
  'not-classified': [],
}

const withFitnessPricingPlans = (appIds: string[], businessSegmentId: string | undefined, experiments: Experiments) => {
  if (!experiments.isEnabled(FITNESS_PRICING_PLANS_SPEC) || businessSegmentId !== FITNESS_SEGMENT_ID) {
    return appIds
  }

  return appIds.includes(ids.PRICING_PLANS) ? appIds : [...appIds, ids.PRICING_PLANS]
}

const segmentToAppIdsV2: Record<string, string[]> = {
  'beauty-wellness-services': [ids.WIX_BOOKINGS, ids.WIX_PORTFOLIO],
  'blog-content': [ids.WIX_BLOG],
  'business-professionals': [ids.WIX_BOOKINGS, ids.FORM_APP],
  'construction-production-services': [ids.WIX_BOOKINGS, ids.FORM_APP, ids.WIX_PORTFOLIO],
  'consumer-stores': [ids.WIX_NEW_STORES, ids.INSTAGRAM_FEED_NEW],
  'creative-services': [ids.WIX_BOOKINGS, ids.WIX_PORTFOLIO],
  education: [ids.WIX_BOOKINGS, ids.WIX_CHALLENGES],
  'field-services': [ids.WIX_BOOKINGS, ids.FORM_APP],
  'fitness-services': [ids.WIX_BOOKINGS, ids.INSTAGRAM_FEED_NEW],
  'health-services': [ids.WIX_BOOKINGS],
  hotels: [ids.WIX_HOTELS_RUNNER],
  'non-profit-communities': [ids.WIX_EVENTS, ids.WIX_DONATIONS, ids.WIX_GROUPS],
  'other-services': [ids.WIX_BOOKINGS],
  photographers: [ids.WIX_PORTFOLIO],
  portfolio: [ids.WIX_PORTFOLIO],
  'private-events': [ids.WIX_EVENTS, ids.WIX_PORTFOLIO],
  'public-events': [ids.WIX_EVENTS],
  'real-estate': [ids.WIX_BOOKINGS, ids.FORM_APP],
  restaurants: [ids.WIX_RESTAURANTS_MENUS_NEW, ids.WIX_RESTAURANTS_ORDERS_NEW],
  'science-technology-services': [ids.FORM_APP],
  'tours-activities-services': [ids.WIX_BOOKINGS, ids.INSTAGRAM_FEED_NEW],
  'wholesale-stores': [ids.WIX_NEW_STORES],
  'not-classified': [],
}

export const getSectorAppIds = (businessSegmentId: string | undefined, experiments: Experiments) => {
  const mapping = experiments.isEnabled(SECTOR_TO_APP_V2_SPEC) ? segmentToAppIdsV2 : segmentToAppIds
  const appIds = mapping[businessSegmentId ?? ''] ?? []
  return withFitnessPricingPlans(appIds, businessSegmentId, experiments)
}
